import React, { useEffect, useState } from "react";
import { ResponsivePie } from "@nivo/pie";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    background: "#fff",
    padding: 10,
    border: "0.5px solid #555",
    borderRadius: 2,
    boxShadow: "0px 0px 2px #000",
    direction: "rtl",
    textAlign: "right",
  },
}));

const PieChartNivo = React.memo(({ data, fake, stock, combine, market }) => {
  const tooltipBody = (d) => {
    return (
      <div className={`${classes.tooltip}`}>
        <div className="inline-block font-semibold">{d.datum.label}</div>
        {/*<span*/}
        {/*  style={{ padding: "0 10px", background: d.datum.color, marginLeft: 3 }}*/}
        {/*></span>*/}
        <div className="grid grid-cols-2 gap-4 w-full text-left my-1">
          <div className="">
            {combine ? "درصد" : stock && !market ? "وزن در سبد" : "مقدار"}
          </div>
          <div className="">{`${d.datum?.data?.percent}%`}</div>
        </div>
        {/* {`${d.datum.label} مقدار %${d.datum.value} از پرتفوی کلی شما را در بر گرفته است`} */}
      </div>
    );
  };

  const classes = useStyles();

  return (
    <ResponsivePie
      data={data}
      margin={{ top: 20, right: 10, bottom: 10, left: 10 }}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.2]],
      }}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      enableArcLinkLabels={false}
      enableArcLabels={false}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      isInteractive={true}
      tooltip={(d) => tooltipBody(d)}
      colors={(d) => d.data.color}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [["darker", 2]],
      }}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      fill={[
        {
          match: {
            id: "ruby",
          },
          id: "dots",
        },
        {
          match: {
            id: "c",
          },
          id: "dots",
        },
        {
          match: {
            id: "go",
          },
          id: "dots",
        },
        {
          match: {
            id: "python",
          },
          id: "dots",
        },
        {
          match: {
            id: "scala",
          },
          id: "lines",
        },
        {
          match: {
            id: "lisp",
          },
          id: "lines",
        },
        {
          match: {
            id: "elixir",
          },
          id: "lines",
        },
        {
          match: {
            id: "javascript",
          },
          id: "lines",
        },
      ]}
      legends={
        [
          // {
          //   anchor: "top-left",
          //   direction: "column",
          //   justify: false,
          //   translateX: -50,
          //   translateY: -12,
          //   itemsSpacing: 5,
          //   itemWidth: 100,
          //   itemHeight: 18,
          //   itemTextColor: "#999",
          //   itemDirection: "left-to-right",
          //   itemOpacity: 1,
          //   symbolSize: 18,
          //   symbolShape: "circle",
          //   effects: [
          //     {
          //       on: "hover",
          //       style: {
          //         itemTextColor: "#000",
          //       },
          //     },
          //   ],
          // },
        ]
      }
    />
  );
});

export default PieChartNivo;
